import Dashboard from '../../components/widget/Dashboard';

function AdminPage(props) {
    return <>
        <div className="container mt-4 pb-5">
            <Dashboard />
        </div>
    </>
}

export default AdminPage;